import { render, staticRenderFns } from "./ErrorLicenseStaff.vue?vue&type=template&id=9b8c7410&"
import script from "./ErrorLicenseStaff.vue?vue&type=script&lang=js&"
export * from "./ErrorLicenseStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports